import { ADD_PRODUCT_MODAL } from "./GlobalParamsActions";

const _nullGlobalParams = {
  addProductState: false,
};
export const globalParamStates = (
  state = _nullGlobalParams,
  { type, data }
) => {
  switch (type) {
    case ADD_PRODUCT_MODAL:
      return { ...state, ...data };
    default:
      return state;
  }
};
